var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"person-container flex"},[_c('left-nav-tab',{attrs:{"code":_vm.code,"navList":_vm.navList},on:{"handleTabPage":_vm.handleTabPage}}),_c('div',{staticClass:"content-box"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }